interface Props {
    /**
     * The progress percentage (0-100). 
     * Determines how much of the ring is filled.
     */
    percentage: number;
}

/**
 * A circular progress indicator that visually represents a percentage.
 * - Displays a progress ring.
 * - When the percentage reaches 100%, the ring turns green and a checkmark appears.
 *
 * @param {Props} percentage - The completion percentage (0-100).
 */
const PercentageRing: React.FC<Props> = ({
    percentage
}: Props) => {
    const radius = 7.5;
    const strokeWidth = 2;
    const circleCircumference = 2 * Math.PI * radius;
    const strokeDashoffset = circleCircumference - (percentage / 100) * circleCircumference;

    return (
        <svg width="17" height="17" viewBox="0 0 17 17">
            {/* Inner circle (only when full) */}
            {percentage === 100 && (
                <circle cx="8.5" cy="8.5" r="7.5" className={`${percentage === 100 ? "fill-holifya-validation-light-green" : "fill-transparent"}`} />
            )}

            {/* Background Circle (Gray) */}
            <circle
                cx="8.5"
                cy="8.5"
                r={radius}
                className="stroke-holifya-validation-grey"
                strokeWidth={strokeWidth}
                fill="transparent"
            />

            {/* Progress Circle */}
            <circle
                cx="8.5"
                cy="8.5"
                r={radius}
                className="stroke-holifya-validation-green"
                strokeWidth={strokeWidth}
                fill="transparent"
                strokeDasharray={circleCircumference}
                strokeDashoffset={strokeDashoffset}
                strokeLinecap="round"
                transform="rotate(-90 8.5 8.5)"
                style={{ transition: "stroke-dashoffset 0.3s ease" }}
            />

            {/* Checkmark (Only visible at 100%) */}
            {percentage === 100 && (
                <path
                    d="M6 9 L8 11 L11 6"
                    className="stroke-holifya-validation-green"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                />
            )}
        </svg>
    );
}

export default PercentageRing
